import type { Appointment } from "@/features/appointments/types/appointmentTypes";
import type { Service } from "../types/serviceTypes";

export const getServiceName = (
  appointment: Appointment,
  services: Service[] | undefined
): string => {
  if (!services) return "Unknown Service";

  if (!appointment.services || appointment.services.length === 0)
    return "No Service";

  const firstService = services.find(
    (s) => s.id === appointment.services?.[0]?.serviceId
  );
  const firstName = firstService?.name || "Unknown Service";

  if (appointment.services.length > 1) {
    return `${firstName} (+${appointment.services.length - 1} more)`;
  }

  return firstName;
};
